import type { EditorCommand } from '@atlaskit/editor-common/types';

import { type AgentManagedExtensionMeta, setMeta } from '../pm-plugins/state';

const dispatchMeta =
	(meta: AgentManagedExtensionMeta): EditorCommand =>
	({ tr }) =>
		setMeta(tr, meta);

/** Open the inline configuration popup for the agent-managed block at the current selection. */
export const openConfig = (): EditorCommand => dispatchMeta({ type: 'OPEN_CONFIG' });

/** Close the inline configuration popup. */
export const closeConfig = (): EditorCommand => dispatchMeta({ type: 'CLOSE_CONFIG' });

/** Toggle the inline configuration popup. */
export const toggleConfig = (): EditorCommand => dispatchMeta({ type: 'TOGGLE_CONFIG' });
